var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[(_vm.decodedFile!=null)?_c('pdf',{attrs:{"id":"pdf","src":_vm.decodedFile,"page":_vm.displayedPage,"resize":true},on:{"numpages":function($event){_vm.pageCount = $event}}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }